import { render, staticRenderFns } from "./CampaignCustomerProperties.vue?vue&type=template&id=0a8ce11b&scoped=true&"
import script from "./CampaignCustomerProperties.vue?vue&type=script&lang=js&"
export * from "./CampaignCustomerProperties.vue?vue&type=script&lang=js&"
import style0 from "./CampaignCustomerProperties.vue?vue&type=style&index=0&id=0a8ce11b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ce11b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRadio } from 'vuetify/lib'
import { VRadioGroup } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
import { VTooltip } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCheckbox,
  VDialog,
  VForm,
  VIcon,
  VRadio,
  VRadioGroup,
  VTextField,
  VTooltip,
})
